export default "__VITE_ASSET__DG$Zq3M5__"